<template>
  <div class="form-group">
    <label v-if="label" class="font-size-12">{{ label }}</label>
    <div class="input-container d-flex">
      <input v-model="iValue" type="text" class="form-control" placeholder="https://example.com" :style="{ flex: '1 1 auto' }" />
      <button class="btn-upload btn-remove" title="Delete" @click="removeVideo">
        <i :class="deleteIcon" />
      </button>
    </div>
  </div>
</template>

<script>
import { DELETE_ICON } from '@src/icons'
export default {
  props: {
    value: { required: false, type: [String], default: '' },
    label: { type: [String], default: '' }
  },
  data() {
    return {
      deleteIcon: DELETE_ICON,
      loadingVideo: false
    }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newVal) { this.$emit('input', newVal) }
    }
  },
  methods: {
    removeVideo() { this.$emit('input', null) }
  }
}
</script>